<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import Statistics from "@/services/Statistics";
import Monitor from "@/services/Monitor";
import DatePicker from "vue2-datepicker";


export default {
  components: { Layout, PageHeader, DatePicker },
  data() {
    return {
      showLoader: false,
      error: null,
      loginData: [],
      items: [] ,
      title: "Login Statistics",
      tenants: [],
      selectedTenant: '',
      selectedSource: '',
      daterange: "",
      excludeAzerionUsers: 1,
      lastLoginsData:[],
      role_source: [],
      loaderCountSuccessRate: false,
      successRateSeries: [],
      loginsPerDaySeries: [],
      tableData: [],
      countSuccessRateOptions: {
        chart: {
          type: "pie",
          height: 320,
          toolbar: { show: true },
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          style: { color: '#6c757d', fontSize: '16px' },
        },
        labels: ["Success", "Failed"], // initial dummy label
        colors: ["#008000", "#FF2C2C"],
        legend: { position: "bottom" },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            const label = opts.w.globals.labels[opts.seriesIndex];
            const count = opts.w.globals.series[opts.seriesIndex];

            return `${label}: ${count} (${val.toFixed(2)}%)`;
          },
        },
        tooltip: {
          y: { formatter: function (val) { return val; } },
        },
      },
      loginsPerDayOptions: {
        chart: { width: "100%", height: 320, type: "bar", stacked: false, toolbar: { show: true } },
        noData: { text: 'No data available', align: 'center', verticalAlign: 'middle', style: { color: '#6c757d', fontSize: '16px' } },
        plotOptions: { bar: { columnWidth: "50%", distributed: true } },
        dataLabels: { enabled: false },
        colors: ["#5b73e8"],
        xaxis: { categories: [], labels: { style: { fontSize:'10px', fontFamily:'Helvetica, Arial, sans-serif', fontWeight:400 } } },
        yaxis: { title: { text: "Login Count" } },
        tooltip: { shared: true, intersect: false, y: { formatter: y => (typeof y !== "undefined" ? y.toFixed(0) : y) } },
        legend: { show: false }
      },
      sortDesc: true,
      filteredItems: [],
      filterOn: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      isBusy: false,
      sortBy: "timestamp",
      fields: [
        {
          key: 'username',
          label: 'Username',
        },
        {
          key: "success",
          label: "Success",
        },
        {
          key: "timestamp",
          label: "Timestamp",
        }
      ],

    };
  },
  async mounted() {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - 10);

    this.daterange = [start, end];

    await this.getTenants()
  },
  methods: {
    async getApplications() {
      this.loaderCountSuccessRate = true;
      try {
        const response = await Statistics.getApplications('tenant='+this.selectedTenant);
        let applications = response.data.data;
        this.role_source = [...new Set(applications.map(app => app.role_source))];
      } catch (error) {
        this.error = error.data ? error.data.error : "An unexpected error occurred.";
      }
    },

    getTenants() {
      this.showLoader = true;
      Monitor.getTenants()
          .then((response) => {
            this.tenants = response.data.tenants;
          })
          .catch((error) => {
            this.error = error.data ? error.data.error : "An unexpected error occurred.";
          })
          .finally(() => {
            this.showLoader = false;
          });
    },

    async getLoginStatistics() {
      try {
        this.loaderCountSuccessRate = true
        this.isBusy = true
        let filters = this.getFilter()
        const response = await Statistics.getLoginStatistics(filters);
        this.loginData = response.data.data;
      } catch (error) {
        this.error = error.response.data.error ? error.response.data.error : "";
      } finally {
        this.loaderCountSuccessRate = false
        this.isBusy = false
        this.buildLoginData()
      }
    },

    getFilter(){

      let filter = '';

      if(this.selectedTenant){
        filter +='tenant='+this.selectedTenant
      }

      if(this.excludeAzerionUsers){
        filter +='&exclude_azerion_users='+this.excludeAzerionUsers
      }

      filter +='&source=app_users';

      if (this.daterange && this.daterange.length === 2) {
        const [start, end] = this.daterange;
        const dateFrom = this.formatLocalDate(start);
        const dateTo = this.formatLocalDate(end);
        filter += `&date_from=${dateFrom}&date_to=${dateTo}`;
      }

      return filter;
    },

    formatLocalDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    clearFilters() {
      this.selectedTenant = ''
      this.daterange = null
    },

    buildLoginData() {

      if (!this.loginData && this.loginData.length === 0) {
        this.successRateSeries = [];
        this.countSuccessRateOptions = {
          ...this.countSuccessRateOptions,
          labels: []
        };
        return;
      }

      // Apply source filter only if selectedSource is set
      this.tableData = this.selectedSource
          ? this.loginData.filter(i => i.source === this.selectedSource)
          : this.loginData;
      this.totalRows = this.tableData.length;

      this.lastLoginsData = [...this.tableData]
          .filter(i => i.success === 1)
          .sort((a, b) => b.timestamp - a.timestamp)
          .slice(0, 5);

      // Count success / failed
      const successCount = this.tableData.filter(i => i.success === 1).length;
      const failedCount  = this.tableData.filter(i => i.success === 0).length;

      // Update chart
      this.successRateSeries = [successCount, failedCount];
      this.countSuccessRateOptions = {
        ...this.countSuccessRateOptions,
        labels: ["Success", "Failed"]
      };


      // ===============================
      // SUCCESSFUL LOGINS PER DAY
      // ===============================

      const perDayMap = {};

      this.tableData
          .filter(i => i.success === 1) // only successful logins
          .forEach(item => {
            // "2025-04-15 12:33:24" → "2025-04-15"
            const day = item.timestamp.split(' ')[0];

            perDayMap[day] = (perDayMap[day] || 0) + 1;
          });

      const days = [];
      const counts = [];

      const start = new Date(this.daterange[0]);
      const end   = new Date(this.daterange[1]);

      // clone date to avoid mutating start
      let current = new Date(start);

      while (current <= end) {
        const day = current.toISOString().split('T')[0]; // YYYY-MM-DD

        days.push(day);
        counts.push(perDayMap[day] || 0);

        current.setDate(current.getDate() + 1);
      }

      this.loginsPerDaySeries = [
        {
          name: "Successful Logins",
          data: counts
        }
      ];

      this.loginsPerDayOptions = {
        ...this.loginsPerDayOptions,
        xaxis: {
          ...this.loginsPerDayOptions.xaxis,
          categories: days
        }
      };
    },

    onFiltered(filteredItems) {
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
  watch: {
    selectedTenant(newValue) {
      this.tableData = []
      this.loginData = []
      this.getApplications()
      this.getLoginStatistics()
      this.totalRows = 0
      this.currentPage = 1
      this.lastLoginsData = []
    },
    selectedSource(newValue) {
      this.buildLoginData()
    },
    daterange(newValue) {
      if(this.selectedTenant){
        this.getLoginStatistics()
      }

      this.totalRows = 0
      this.currentPage = 1
      this.lastLoginsData = []
    },
    excludeAzerionUsers(newValue){
      if(this.selectedTenant){
        this.getLoginStatistics()
      }

      this.totalRows = 0
      this.currentPage = 1
      this.lastLoginsData = []
    }
  },
  middleware: "authentication",
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="!showLoader">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 d-inline-flex align-items-center">
                <label class="control-label form-label" style="width: 180px">Filter by Tenant</label>
                <select
                    v-model="selectedTenant"
                    class="form-control form-select"
                    name="option"
                    type="select"
                >
                  <option value="" key=""></option>
                  <option v-for="tenant in tenants" :key="tenant" :value="tenant">
                    {{ tenant }}
                  </option>
                </select>
              </div>

<!--              <div class="col-md-4 d-inline-flex align-items-center">
                <label class="control-label form-label" style="width: 180px">Role Source</label>
                <select
                    v-model="selectedSource"
                    class="form-control form-select"
                    name="option"
                    type="select"
                >
                  <option value="" key=""></option>
                  <option v-for="source in role_source" :key="source" :value="source">
                    {{ source }}
                  </option>
                </select>
              </div>-->

              <div class="col-md-4 d-inline-flex align-items-center">
                <label class="control-label form-label" style="width: 180px">Choose Dates</label>
                <date-picker
                    v-model="daterange"
                    range
                    append-to-body
                    lang="en"
                    confirm
                ></date-picker>
              </div>


              <div class="col-md-4 d-inline-flex align-items-center">
                <b-form-checkbox-group>
                  <div class="form-check form-switch form-switch-lg ms-5 mb-2">
                    <input v-model="excludeAzerionUsers"
                           type="checkbox"
                           class="form-check-input"
                           id="excludeAzerionUsers"
                    />
                    <label class="form-check-label" for="excludeAzerionUsers">Exclude Azerion Users</label>
                  </div>
                </b-form-checkbox-group>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">

            <div class="row">
              <div class="col-sm-4">
                <span class="h5 ms-3 d-block d-md-inline">Login Success Rate</span>
                <apexchart
                    v-if="!loaderCountSuccessRate"
                    class="apex-charts"
                    height="320"
                    type="pie"
                    dir="ltr"
                    :series="successRateSeries"
                    :options="countSuccessRateOptions"
                ></apexchart>
                <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                  <b-spinner large></b-spinner>
                </div>
              </div>

              <div class="col-sm-5">
                <span class="h5 ms-3 d-block d-md-inline">Successful Logins per Day</span>
                <apexchart
                    v-if="!loaderCountSuccessRate"
                    class="apex-charts"
                    height="350"
                    type="bar"
                    dir="ltr"
                    :series="loginsPerDaySeries"
                    :options="loginsPerDayOptions"
                ></apexchart>
                <div class="col-12 mt-5 d-flex align-items-center justify-content-center" v-else>
                  <b-spinner large></b-spinner>
                </div>
              </div>

              <div class="col-sm-3">
                <h5>Last 5 Successful Logins</h5>
                <table class="table table-striped mb-0">
                  <thead>
                  <tr>
                    <th>Username</th>
                    <th>Timestamp</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-if="lastLoginsData.length === 0">
                      <td colspan="2" class="text-center text-muted">No data</td>
                    </tr>
                    <tr v-else v-for="userLogin in lastLoginsData" :key="userLogin.id">
                      <td>{{ userLogin.username }}</td>
                      <td>{{ userLogin.timestamp }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>


            </div>

            <div class="row mt-5">
              <div class="col-sm-12 col-md-3">
                <h5>Complete Login Data</h5>
              </div>
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-12 col-md-3">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show&nbsp;
                        <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;entries
                      </label>
                    </div>
                  </div>

                  <!-- Search -->
                  <div class="col-sm-12 col-md-9">
                    <div id="deals-table_filter" class="dataTables_filter text-md-end">
                      <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                      :items="tableData"
                      :busy="isBusy"
                      :fields="fields"
                      :visible="fields.visible"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      show-empty
                      empty-text="No Data Found"
                  >

                    <template #cell(success)="data">
                      <span v-if="data.item.success">True</span>
                      <span v-else>False</span>
                    </template>

                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>

                  </b-table>
                </div>
                <!--Table end -->

                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <div v-else>
      <div class="card-body d-flex align-items-center justify-content-center">
        <b-spinner large></b-spinner>
      </div>
    </div>
  </Layout>
</template>
